export enum WizardStep {
  ContactUs = "contactUs",
  MachineTonnage = "machineTonnage",
  Market = "market",
  Optional = "optional",
  Product = "product",
}

export enum WizardStepIndex {
  Market = 0,
  MachineTonnage = 1,
  Product = 2,
  Optional = 3,
  ContactUs = 4,
  Done = 5,
}
